export default function PrivacyPage() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Instrument+Sans:wght@400;500;600;700&family=Instrument+Serif:ital@0;1&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #0c0a09; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

        .pp-hero { animation: fadeUp 0.5s ease both; }
        .pp-section { animation: fadeUp 0.5s ease both; }
        .pp-section:nth-child(2) { animation-delay: 0.05s; }
        .pp-section:nth-child(3) { animation-delay: 0.1s; }
        .pp-section:nth-child(4) { animation-delay: 0.15s; }
        .pp-section:nth-child(5) { animation-delay: 0.2s; }
        .pp-section:nth-child(6) { animation-delay: 0.25s; }
        .pp-section:nth-child(7) { animation-delay: 0.3s; }

        @media (max-width: 640px) {
          .pp-nav-wordmark { font-size: 17px !important; }
          .pp-hero-title { font-size: 28px !important; }
          .pp-hero-meta { flex-direction: column !important; gap: 6px !important; }
          .pp-content { padding: 24px 18px 60px !important; }
          .pp-section-title { font-size: 15px !important; }
          .pp-body { font-size: 14px !important; }
          .pp-highlight { padding: 14px 16px !important; }
          .pp-contact-grid { grid-template-columns: 1fr !important; }
          .pp-nav-inner { padding: 0 16px !important; }
          .pp-hero-inner { padding: 32px 18px 28px !important; }
        }
      `}</style>

      <div style={{ background: "#0c0a09", minHeight: "100vh", fontFamily: "'Instrument Sans', sans-serif", color: "#e7e5e0" }}>

        {/* Nav */}
        <nav style={{ position: "sticky", top: 0, zIndex: 100, background: "rgba(12,10,9,0.92)", backdropFilter: "blur(12px)", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <div className="pp-nav-inner" style={{ maxWidth: 760, margin: "0 auto", padding: "0 24px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <a href="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
              <div style={{ width: 28, height: 28, background: "#d97706", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: "#0c0a09", fontWeight: 800 }}>✦</div>
              <span className="pp-nav-wordmark" style={{ fontFamily: "'Syne', sans-serif", fontSize: 18, fontWeight: 800, color: "#fafaf9" }}>Limji</span>
            </a>
            <a href="/" style={{ fontSize: 13, fontWeight: 600, color: "#78716c", textDecoration: "none", display: "flex", alignItems: "center", gap: 5 }}>
              ← Back to home
            </a>
          </div>
        </nav>

        {/* Hero band */}
        <div style={{ borderBottom: "1px solid rgba(255,255,255,0.06)", background: "linear-gradient(135deg, #111110 0%, #0c0a09 100%)" }}>
          <div className="pp-hero-inner" style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 36px" }}>
            <div className="pp-hero" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "rgba(217,119,6,0.1)", border: "1px solid rgba(217,119,6,0.25)", borderRadius: 20, padding: "4px 12px", width: "fit-content" }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#d97706", letterSpacing: "0.08em", textTransform: "uppercase" }}>Legal</span>
              </div>
              <h1 className="pp-hero-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 36, fontWeight: 800, color: "#fafaf9", letterSpacing: "-0.02em", lineHeight: 1.1 }}>
                Privacy Policy
              </h1>
              <div className="pp-hero-meta" style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
                <span style={{ fontSize: 13, color: "#57534e" }}>Effective: 1 March 2026</span>
                <span style={{ fontSize: 13, color: "#292524" }}>·</span>
                <span style={{ fontSize: 13, color: "#57534e" }}>Last updated: 1 March 2026</span>
              </div>
              <p style={{ fontSize: 15, color: "#78716c", lineHeight: 1.7, maxWidth: 580, marginTop: 4 }}>
                Limji is built to help small businesses communicate better. This policy explains what data we collect, why, and how we protect it. We keep it simple and honest.
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="pp-content" style={{ maxWidth: 760, margin: "0 auto", padding: "40px 24px 80px", display: "flex", flexDirection: "column", gap: 36 }}>

          {/* Who we are */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              1. Who We Are
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              Limji ("we", "us", "our") operates the website at <strong style={{ color: "#e7e5e0" }}>limji.app</strong> and provides AI-powered tools for small businesses — including Smart Ads, Smart Email, and Smart Orders. We are an independent product and are not affiliated with any large corporation or data broker.
            </p>
          </div>

          {/* What we collect */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              2. What We Collect
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 16 }}>
              We collect only what's necessary to run the service:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { icon: "👤", title: "Account information", desc: "Your name and email address when you create an account via Clerk." },
                { icon: "⚙️", title: "Usage data", desc: "How many generations you've used today, to enforce daily limits and prevent abuse." },
                { icon: "💳", title: "Payment information", desc: "Processed entirely by Stripe. We never see or store your card details." },
                { icon: "📦", title: "Order data", desc: "Smart Orders data (customer names, phone numbers, order details) is stored locally on your device only. We do not send this to our servers." },
                { icon: "🌐", title: "IP address", desc: "Used to enforce anonymous usage limits (10 free tries). Not sold or shared." },
              ].map(item => (
                <div key={item.title} style={{ display: "flex", gap: 14, padding: "14px 16px", background: "#111110", border: "1px solid #1c1917", borderRadius: 12 }}>
                  <span style={{ fontSize: 18, flexShrink: 0, marginTop: 1 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#e7e5e0", marginBottom: 3 }}>{item.title}</div>
                    <div style={{ fontSize: 13, color: "#78716c", lineHeight: 1.6 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* How we use it */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              3. How We Use Your Data
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              Your data is used exclusively to:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
              {[
                "Provide and improve the Limji service",
                "Enforce usage limits and prevent abuse",
                "Process payments and manage subscriptions via Stripe",
                "Send transactional emails (e.g. receipt, password reset) via Clerk",
                "Diagnose technical issues and monitor performance",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#d97706", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✦</span>
                  {item}
                </div>
              ))}
            </div>
            <div className="pp-highlight" style={{ marginTop: 16, padding: "14px 18px", background: "rgba(217,119,6,0.06)", border: "1px solid rgba(217,119,6,0.2)", borderRadius: 12 }}>
              <p style={{ fontSize: 13, color: "#a8a29e", lineHeight: 1.7, margin: 0 }}>
                <strong style={{ color: "#d97706" }}>We do not sell your data.</strong> We do not use your data to train AI models. We do not share your data with advertisers. Limji products are ad-free.
              </p>
            </div>
          </div>

          {/* Third parties */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              4. Third-Party Services
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 16 }}>
              We use trusted third-party services to run Limji. Each has its own privacy policy:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { name: "Clerk", role: "Authentication & account management", url: "clerk.com/privacy" },
                { name: "Stripe", role: "Payment processing", url: "stripe.com/privacy" },
                { name: "Anthropic", role: "AI content generation (your prompts are processed but not stored by us)", url: "anthropic.com/privacy" },
                { name: "Railway", role: "Backend hosting & database", url: "railway.app/privacy" },
                { name: "Vercel", role: "Frontend hosting", url: "vercel.com/legal/privacy-policy" },
              ].map(item => (
                <div key={item.name} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "12px 16px", background: "#111110", border: "1px solid #1c1917", borderRadius: 12, flexWrap: "wrap" }}>
                  <div>
                    <span style={{ fontSize: 14, fontWeight: 700, color: "#e7e5e0" }}>{item.name}</span>
                    <span style={{ fontSize: 13, color: "#57534e", marginLeft: 10 }}>{item.role}</span>
                  </div>
                  <a href={`https://${item.url}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: "#d97706", textDecoration: "none", fontWeight: 600, whiteSpace: "nowrap" }}>
                    View policy →
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Data retention */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              5. Data Retention & Deletion
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              You can delete your account at any time from the Account page. When you do:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
              {[
                "Your account and email are deleted from Clerk immediately",
                "Your usage records are deleted from our database",
                "Your subscription is cancelled in Stripe (no future charges)",
                "Smart Orders data is stored on your device — clearing your browser clears it",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#d97706", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✦</span>
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* Cookies */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              6. Cookies & Local Storage
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              We use browser <strong style={{ color: "#e7e5e0" }}>localStorage</strong> to save your preferences (dark/light mode, generation history, order data) on your device. Clerk uses cookies for authentication sessions. We do not use advertising cookies or tracking pixels.
            </p>
          </div>

          {/* Your rights */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              7. Your Rights
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8, marginBottom: 12 }}>
              Regardless of where you are located, you have the right to:
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingLeft: 4 }}>
              {[
                "Access the personal data we hold about you",
                "Request correction of inaccurate data",
                "Request deletion of your account and data",
                "Opt out of any non-essential communications",
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: "#a8a29e", lineHeight: 1.6 }}>
                  <span style={{ color: "#d97706", fontWeight: 800, flexShrink: 0, marginTop: 1 }}>✦</span>
                  {item}
                </div>
              ))}
            </div>
            <p style={{ fontSize: 14, color: "#57534e", lineHeight: 1.7, marginTop: 14 }}>
              To exercise any of these rights, email us at <strong style={{ color: "#a8a29e" }}>privacy@limji.app</strong> and we'll respond within 7 days.
            </p>
          </div>

          {/* Contact */}
          <div className="pp-section">
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              8. Contact
            </h2>
            <div style={{ padding: "20px", background: "#111110", border: "1px solid #1c1917", borderRadius: 14 }}>
              <p style={{ fontSize: 14, color: "#78716c", lineHeight: 1.7, marginBottom: 14 }}>
                Questions about this policy or your data? We're a small team and we respond personally.
              </p>
              <div className="pp-contact-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <a href="mailto:privacy@limji.app" style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "#1c1917", border: "1px solid #292524", borderRadius: 10, textDecoration: "none" }}>
                  <span style={{ fontSize: 16 }}>✉️</span>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#57534e", letterSpacing: "0.06em", textTransform: "uppercase" }}>Email</div>
                    <div style={{ fontSize: 13, color: "#d97706", fontWeight: 600 }}>privacy@limji.app</div>
                  </div>
                </a>
                <a href="https://limji.app" style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "#1c1917", border: "1px solid #292524", borderRadius: 10, textDecoration: "none" }}>
                  <span style={{ fontSize: 16 }}>🌐</span>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: "#57534e", letterSpacing: "0.06em", textTransform: "uppercase" }}>Website</div>
                    <div style={{ fontSize: 13, color: "#d97706", fontWeight: 600 }}>limji.app</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          {/* Changes */}
          <div className="pp-section" style={{ paddingBottom: 8 }}>
            <h2 className="pp-section-title" style={{ fontFamily: "'Syne', sans-serif", fontSize: 16, fontWeight: 800, color: "#fafaf9", marginBottom: 12, letterSpacing: "-0.01em" }}>
              9. Changes to This Policy
            </h2>
            <p className="pp-body" style={{ fontSize: 15, color: "#a8a29e", lineHeight: 1.8 }}>
              If we make significant changes, we'll notify signed-in users by email at least 7 days in advance. The "Last updated" date at the top of this page will always reflect the most recent version.
            </p>
          </div>

        </div>

        {/* Footer */}
        <footer style={{ borderTop: "1px solid rgba(255,255,255,0.05)", padding: "24px 24px 32px" }}>
          <div style={{ maxWidth: 760, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 22, height: 22, background: "#d97706", borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#0c0a09" }}>✦</div>
              <span style={{ fontFamily: "'Syne', sans-serif", fontSize: 14, fontWeight: 800, color: "#44403c" }}>Limji</span>
            </div>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
              <a href="/privacy" style={{ fontSize: 12, color: "#d97706", textDecoration: "none", fontWeight: 600 }}>Privacy Policy</a>
              <a href="/terms" style={{ fontSize: 12, color: "#44403c", textDecoration: "none" }}>Terms of Service</a>
              <a href="/" style={{ fontSize: 12, color: "#44403c", textDecoration: "none" }}>Home</a>
            </div>
            <span style={{ fontSize: 12, color: "#292524" }}>© 2026 Limji</span>
          </div>
        </footer>

      </div>
    </>
  );
}
